import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { AutenticacionService } from '../../services/autenticacion.service';
import { Firma_ElectronicaService } from 'src/app/services/firma_electronica.service';
import { Firma_Electronica_Lista } from 'src/app/models/generic/Firma_Electronica_Lista';
import { RespuestaGenerica } from 'src/app/models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';

@Component({
  selector: 'firma-electronica',
  templateUrl: './firma-electronica.component.html',
  styleUrls: ['./firma-electronica.component.scss']
})
export class FirmaElectronicaComponent implements OnInit{
  
  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  dataSource: MatTableDataSource<Firma_Electronica_Lista>;
  columnasEncabezado: string[] = ['nroDocumento', 'descripcionEstado', 'fechaCreacion', 'nombreCompleto', 'descripcionProducto', 'tipoFirmaElectronica', 'acciones'];
  listaDatos: Firma_Electronica_Lista[] = [];
  itemSeleccionadoFirma: Firma_Electronica_Lista;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Firma_ElectronicaService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.ConsultarPendientes();
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      nroIdentificacion: [''],
      nombres: ['']
    });
  }
  ConsultarPendientes() {
    this.mostrarCargando = true;
    this.datosServices.ConsultarPendientes()
              .subscribe((resp: RespuestaGenerica) =>{
                this.ConsultarRegistros();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
                this.ConsultarRegistros();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRegistros() {
    this.mostrarCargando = true;
    this.datosServices.Consultar(this.form.value)
              .subscribe((resp: Firma_Electronica_Lista[]) =>{
                this.mostrarCargando = false;
                this.listaDatos = resp;
                this.datosServices.ListaFirmaElectronica = resp;
                this.recargarLista();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }
  recargarLista() {
    this.dataSource = new MatTableDataSource(this.listaDatos);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  refrescarDetalle(itemSeleccionado: Firma_Electronica_Lista) {
    this.mostrarCargando = true;
    this.datosServices.EnviarRecordatorio(itemSeleccionado)
            .subscribe((resp: RespuestaGenerica) =>{
              this.utilitariosService.MensajeToast(resp.mensaje);
              this.mostrarCargando = false;
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  eliminarDetalle(itemSeleccionado: Firma_Electronica_Lista) {
    this.itemSeleccionadoFirma = itemSeleccionado;
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      this.mostrarCargando = true;
      this.datosServices.Eliminar(this.itemSeleccionadoFirma)
              .subscribe((resp: RespuestaGenerica) =>{
                this.mostrarCargando = false;
                if (resp.procesoExitoso == false) {
                  this.utilitariosService.MensajeToast(resp.mensaje);
                } else {
                  this.ConsultarRegistros();
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
    }
  }
  MostrarDescargarDocumento(itemSeleccionado: Firma_Electronica_Lista):boolean {
    return itemSeleccionado.estado === 'FINISH' || itemSeleccionado.estado === 'FINISHED';
  }
  descargarDocumento(itemSeleccionado: Firma_Electronica_Lista) {
    this.mostrarCargando = true;
    this.datosServices.DescargarDocumento(itemSeleccionado)
            .subscribe((resp: any) =>{
              this.mostrarCargando = false;
              let dataType = resp.type;
              let binaryData = [];
              binaryData.push(resp);
              let downloadLink = document.createElement('a');
              downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
              downloadLink.setAttribute('download', `${itemSeleccionado.descripcionNombreDocumento}.pdf`);
              document.body.appendChild(downloadLink);
              downloadLink.click();
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  TituloOpcionMenu(): string {
    return this.menuService.ObtenerTituloOpcionComponente('FirmaElectronicaComponent');
  }
  HabilitarOpcionesEdicion(): boolean {
    return this.menuService.TienePermisoEscrituraEnMenu('FirmaElectronicaComponent');
  }
  TipoFirmaAuco(itemSeleccionado: Firma_Electronica_Lista): boolean {
    return itemSeleccionado.tipoFirmaElectronica === 'AUCO' && itemSeleccionado.descripcionEstado === 'Pendiente' && this.utilitariosService.VerificarContieneDatosTexto(itemSeleccionado.codigoFirmaElectronica);
  }
}
